'use client';
import {
    Button,
    FormControl,
    TextField,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import Logo from '@/components/Logo';
import Footer from '@/components/Footer';
import styles from './page.module.css';
import Benefits from '@/app/home_defs/benefits';
import Faqs from '@/app/home_defs/faqs';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Parse from 'html-react-parser';
import { useState } from 'react';
import ApplyForm from './overlays/applyForm';
import VerifyEmailDialog from './overlays/verifyEmailDialog';
import { useSearchParams } from 'next/navigation';
import { useRouter, usePathname } from 'next/navigation';
import { useEffect, Suspense } from 'react';

function VerifyUserModal({
    activeModal,
    setActiveModal
}: Readonly<{
    activeModal: string;
    setActiveModal: React.Dispatch<React.SetStateAction<string>>;
}>) {

    const router = useRouter();
    const pathname = usePathname();

    const searchParams = useSearchParams();
    const action = searchParams.get('action');

    useEffect(() => {
        const hash = searchParams.get('hash');
        if (hash !== null) {
            if (activeModal === '') {
                setActiveModal('userVerifying');
            }
        }
        if (activeModal === 'userVerifying') {
            fetch(
                '/api/verifyUser',
                {
                    method: 'POST',
                    body: JSON.stringify({ base64encoded_hash: hash })
                }
            )
                .then((res) => res.json())
                .then((verifyHashResult) => {
                    console.log('verifyHashResult', verifyHashResult);
                    if (verifyHashResult.user_verified === true) {
                        setActiveModal('userVerifyConfirmed');
                    } else {
                        setActiveModal('userVerifyFailed');
                    }
                });
        }
    }, [ activeModal, setActiveModal, searchParams ]);

    return (
        action === 'verify' && <VerifyEmailDialog
            activeModal={activeModal}
            onClose={() => {
                setActiveModal('');
                router.push(pathname);
            }}
        />
    );

}

export default function Home() {

    const [ activeModal, setActiveModal ] = useState('');
    const [ email, setEmail ] = useState('');

    return (
        <div className={styles.page}>
            <title>Apex Signals</title>
                <main className={styles.main}>
                    <section className={styles.homeHero}>
                        <header className={styles.homeHeroHeader}>
                            <div className="left-flex">
                                <Logo mode="dark"/>
                            </div>
                            <div className="right-flex">
                                <Button
                                    variant="contained"
                                    onClick={() => setActiveModal('applyForm')}
                                >
                                    Apply for early access
                                </Button>
                            </div>
                        </header>
                        <div className={styles.homeHeroContent}>
                            <div className={styles.homeHeroLeftContent}>
                                <h1 className={styles.h1}>Outperform the Market on <span className={styles.h1Highlight}>Autopilot</span></h1>
                                <h2 className={styles.h2}>Apex Signals is the next generation stock recommendation platform for any investor to beat the market with data-backed insights</h2>
                            </div>
                            <div className={styles.homeHeroRightContent}>
                                <div className={styles.homeHeroImage}>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className={styles.homeBenefits}>
                        <h3 className={styles.h3}>Why <em>Apex Signals</em>?</h3>
                        <div className={styles.homeBenefitsGrid}>
                            {Benefits.map((benefit, index) => {
                                return (
                                    <div className={styles.homeBenefitItem} key={index}>
                                        <div className={styles.homeBenefitItemIcon}>
                                            {benefit.icon}
                                        </div>
                                        <div className={styles.homeBenefitItemTitle}>{benefit.title}</div>
                                        <div className={styles.homeBenefitItemDescription}>
                                            {Parse(benefit.description)}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </section>
                    <section className={styles.homeSignup}>
                        <div>
                            <h3 className={styles.h3}>Apply to Join the Beta</h3>
                            <h4 className={styles.h4}>Sign up today to stay in the loop and get early access</h4>
                        </div>
                        <FormControl className={styles.homeApplyOpen}>
                            <TextField
                                hiddenLabel
                                className={styles.homeApplyEmail}
                                id="home-apply-email"
                                placeholder="Your email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Button
                                variant="contained"
                                className={styles.homeApplySubmit}
                                onClick={() => setActiveModal('applyForm')}
                            >
                                Apply
                            </Button>
                        </FormControl>
                    </section>
                    <section className={styles.homeFAQ}>
                        <h3 className={styles.h3}>Frequently Asked Questions</h3>
                        <div className={styles.homeFAQList}>
                            {Faqs.map((item, index) => {
                                return (
                                    <Accordion className={styles.homeAccordion} key={index}>
                                        <AccordionSummary className={styles.homeAccordionSummary} expandIcon={<ArrowDropDownIcon/>}>
                                            {Parse(item.summary)}
                                        </AccordionSummary>
                                        <AccordionDetails className={styles.homeAccordionDescription}>
                                            {item.description}
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })}
                        </div>
                    </section>
                </main>
            <Footer />
            <ApplyForm
                isActive={activeModal === 'applyForm'}
                onClose={() => setActiveModal('')}
                email={email}
                onEmailChange={(value) => setEmail(value)}
            />
            <Suspense fallback={<div>Loading...</div>}>
                <VerifyUserModal
                    activeModal={activeModal}
                    setActiveModal={setActiveModal}
                />
            </Suspense>
        </div>
    );  
}